import { Badge } from '@/components/ui/badge';
import { Info } from 'lucide-react';
import { ExceptionLog } from '../types/exception-log';
import { ExceptionTooltipContent } from './exception-tooltip-content';

interface ExceptionBadgeProps {
  exceptionLogs: ExceptionLog[] | undefined;
  className?: string;
  side?: 'top' | 'right' | 'bottom' | 'left';
}

export function ExceptionBadge({
  exceptionLogs,
  className = '',
  side = 'left',
}: ExceptionBadgeProps) {
  if (!exceptionLogs || exceptionLogs.length === 0) {
    return null;
  }

  const count = exceptionLogs.length;

  return (
    <div className={`flex items-center gap-1 ${className}`}>
      <Badge variant="outline" className="text-xs flex items-center gap-1 capitalize">
        {count} exception{count !== 1 ? 's' : ''} granted
        <ExceptionTooltipContent
            exceptionLogs={exceptionLogs}
            side={side}
            trigger={
            <Info className="h-3.5 w-3.5 cursor-help" />
            }
        />
      </Badge>
    </div>
  );
}

